<div class="container pt-5 my-5">
  <table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Designation</th>
        <th scope="col">Member Name</th>
        <th scope="col">Contact Number</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th scope="row">1</th>
        <td>Sarapanch</td>
        <td>Gouri Naik</td>
        <td>8018272302</td>
      </tr>
      <tr>
        <th scope="row">2</th>
        <td>PEO</td>
        <td>Sanjay kumar Mohanta</td>
        <td>9437141546</td>
      </tr>
      <tr>
        <th scope="row">3</th>
        <td>PS Member</td>
        <td>Mamata Behera</td>
        <td>8327702067</td>
      </tr>
      <tr>
        <th scope="row">4</th>
        <td>ZP</td>
        <td>Asish Chakrabarti</td>
        <td>9437200588</td>
      </tr>
      <tr>
        <th scope="row">5</th>
        <td>Naib Sarapanch</td>
        <td>Kabita Mahakud</td>
        <td>7751979833</td>
      </tr>
      <tr>
        <th scope="row">6</th>
        <td>Wardmember</td>
        <td>Baula Mahanta</td>
        <td>9668606086</td>
      </tr>
      <tr>
        <th scope="row">7</th>
        <td>Wardmember</td>
        <td>Sabita Naik</td>
        <td>9827972502</td>
      </tr>
      <tr>
        <th scope="row">8</th>
        <td>Wardmember</td>
        <td>Purna Chandra Mahanta</td>
        <td>9861342258</td>
      </tr>
      <tr>
        <th scope="row">9</th>
        <td>Wardmember</td>
        <td>Lalita Mahanta</td>
        <td>7008230255</td>
      </tr>
      <tr>
        <th scope="row">10</th>
        <td>Wardmember</td>
        <td>Paira Behera</td>
        <td>7978989028</td>
      </tr>
      <tr>
        <th scope="row">11</th>
        <td>Wardmember</td>
        <td>Kabita Mahakud</td>
        <td>775197983</td>
      </tr>
      <tr>
        <th scope="row">12</th>
        <td>Wardmember</td>
        <td>Pradeep Kumar Naik</td>
        <td>7735236593</td>
      </tr>
      <tr>
        <th scope="row">13</th>
        <td>Wardmember</td>
        <td>Sebati Naik</td>
        <td>9777885562</td>
      </tr>
      <tr>
        <th scope="row">14</th>
        <td>Wardmember</td>
        <td>Sankarsana Naik</td>
        <td>7854911547</td>
      </tr>
      <tr>
        <th scope="row">15</th>
        <td>Wardmember</td>
        <td>Champabati Naik</td>
        <td>7991082372</td>
      </tr>
      <tr>
        <th scope="row">17</th>
        <td>Wardmember</td>
        <td>Bhaktabandhu Mahanta</td>
        <td>9348619132</td>
      </tr>
      <tr>
        <th scope="row">18</th>
        <td>Wardmember</td>
        <td>Akshay Kumar Naik</td>
        <td>9861153813</td>
      </tr>
      <tr>
        <th scope="row">19</th>
        <td>Wardmember</td>
        <td>Mitrabhanu Mahakud</td>
        <td>8917665709</td>
      </tr>
      <tr>
        <th scope="row">20</th>
        <td>Wardmember</td>
        <td>Bharati Hembrem</td>
        <td>7978805508</td>
      </tr>
      <tr>
        <th scope="row">21</th>
        <td>Wardmember</td>
        <td>Lalmohan Naik</td>
        <td>7735655318</td>
      </tr>
    </tbody>
  </table>
</div>
